import { Component, Vue } from 'vue-property-decorator'
import { queryHomehelp } from '@/api'

@Component({ name: 'QaPage' })
export default class QaPage extends Vue {
  private qaData = []
  created () {
    this.queryQA()
  }

  private async queryQA () {
    const result: any = await queryHomehelp({})
    this.qaData = result.help
  }
}
